import { Button, CircularProgress, Icon, InputAdornment, TextField } from '@material-ui/core';
import MyCollapse from 'components/Collapse';
import { emailIsValid } from 'helpers/functions';
import React, { Fragment, memo, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable } from 'react-use-observable';
import { tap } from 'rxjs/operators';
import subscriptionsService from 'v2/services/subscriptions';

import type { ISubscriptions } from 'v2/interfaces/subscriptions';

interface IProps {
  contract: ISubscriptions;
}

const AddAffiliate = memo(({ contract }: IProps) => {
  const [affiliateEmail, setAffiliateEmail] = useState(contract?.affiliate?.email || '');
  const [inputFocus, setInputFocus] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasAffiliate, setHasAffiliate] = useState(contract?.affiliate?.id !== 0 || false);

  const getErrorForField = useMemo(() => {
    if (!affiliateEmail) {
      return false;
    }

    if (!inputFocus) {
      return false;
    }

    return !emailIsValid(affiliateEmail);
  }, [affiliateEmail, inputFocus]);

  const handleChangeFieldAffiliate = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAffiliateEmail(e.target.value);
  };
  const [handleClickAdcAffiliate] = useCallbackObservable(() => {
    setIsSubmitting(true);
    return subscriptionsService.addAffiliate(contract.id, affiliateEmail).pipe(
      tap(
        () => {
          setIsSubmitting(false);
          setHasAffiliate(true);
          toast.success('Afiliado adicionado com sucesso');
        },
        () => {
          setIsSubmitting(false);
          toast.error('Não foi possível adicionar o afiliado');
        }
      )
    );
  }, [affiliateEmail, contract]);

  const isDisabled = getErrorForField || !affiliateEmail || hasAffiliate;

  return (
    <Fragment>
      <MyCollapse title='Adicionar Afiliado' arrow>
        <div>
          <TextField
            fullWidth
            placeholder='E-mail do afiliado'
            onChange={handleChangeFieldAffiliate}
            value={affiliateEmail}
            onFocus={() => setInputFocus(true)}
            helperText={getErrorForField ? 'Digite um e-mail válido' : ''}
            error={getErrorForField}
            disabled={hasAffiliate}
            InputProps={{
              disableUnderline: true,
              endAdornment: (
                <InputAdornment position='end'>
                  <Button size='small' onClick={handleClickAdcAffiliate} disabled={isDisabled}>
                    {isSubmitting ? <CircularProgress size={14} /> : <Icon style={{ color: '#777', fontSize: 20 }}>send</Icon>}
                  </Button>
                </InputAdornment>
              ),
            }}
          />

          {hasAffiliate && <small style={{ marginTop: 4 }}>Este contrato possui afiliado.</small>}
        </div>
      </MyCollapse>
      <div className='m24' />
    </Fragment>
  );
});

export default AddAffiliate;
